import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class CsvDataService {
    constructor(public datepipe: DatePipe, public currency: CurrencyPipe, public decimal: DecimalPipe) {
    }
    serviceType: number;
    exportToCsv(filename: string, rows: object[], colDetails: object, colsToExport: string[], serviceType = 0) {
        this.serviceType = serviceType;
        if (!rows || !rows.length) {
            return;
        }
        const separator = ',';
        const keys = colsToExport;  // Object.keys(rows[0]);
        const csvContent = 
            keys.map(k => {
                return colDetails[k]['heading'];
            }).join(separator) +
            '\n' +
            rows.map(row => {
                return keys.map(k => {
                    let formattedVal = '';
                    let colDetail = colDetails[k];
                    let dataFieldName = colDetail['dataFieldName'];
                    let cell = (row[dataFieldName] === null || row[dataFieldName] === undefined)? '' : row[dataFieldName];
                                      
                    var dataType = (typeof cell);
                    if((cell != null && cell != '') && dataType=="string" && cell.startsWith('=')) {
                        cell = "'" + cell; 
                    } 

                    if((cell != null && cell != '') || colDetail['dataFormat'] === 'datewithnullcheck' 
                            || colDetail['dataFormat'] === 'percentToFixed' || colDetail['dataFormat'] === 'currency') {
                        formattedVal = this.formatFieldVal(cell, colDetail, row);
                    }                  
                    else {
                        formattedVal = cell;
                    }        
                              
                  
                    return formattedVal;
                }).join(separator);
            }).join('\n');

        const BOM = '\uFEFF'; // Use this and utf8 to support hebrew
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');

            if (link.download !== undefined) {
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }



    formatFieldVal(cell: any, colDetail: object, row: object) {
        let retVal = '';
        if(colDetail['dataFormat']) {
            if (colDetail['dataFormat'] === 'date') {
                if(colDetail['dateFormat']) {
                    retVal = this.datepipe.transform(cell, colDetail['dateFormat']);
                } else {
                    retVal = this.datepipe.transform(cell,'MM/dd/yyyy');
                }
            } else if (colDetail['dataFormat'] === 'currency') {                
                if(typeof(cell) == "string"){
                    cell=cell.replace(",","");
                }
                if (cell == 'null' || !cell || cell =='') {
                    cell = 0;
                }
                if(colDetail['currencyCodeField']) {
                    retVal = this.currency.transform (cell, row[colDetail['currencyCodeField']], 'symbol-narrow', '1.2-2') + 
                            " (" + row[colDetail['currencyCodeField']] + ")";
                } else {
                    retVal = this.currency.transform (cell, '$', 'symbol-narrow-', '1.2-2');
                }
            
            } else if (colDetail['dataFormat'] === 'countryRegion') {
                retVal = (row['Region'] ? row['Region'] + ', ' + 
                        row[colDetail['dataFieldName']] : row[colDetail['dataFieldName']]);
            
            } else if (colDetail['dataFormat'] === 'decimal') {
                retVal = this.decimal.transform(cell,'1.2-2');
            
            } else if (colDetail['dataFormat'] === 'datewithnullcheck') {
                if(cell!=null && cell!='')
                {
                    retVal = this.datepipe.transform(cell,'MM/dd/yyyy');
                }
                else{
                    retVal ='Not Paid';
                }

            } else if (colDetail['dataFormat'] === 'percentToFixed') {                
                retVal = Number(cell).toFixed(2) + '%';
            
            } else if (colDetail['dataFormat'] === 'formattedUSandClientMarkup') {
                if (row['Country'] == 'USA' && this.serviceType == 1) {
                    retVal = row['ClientMarkup'] + '%';//(row['ClientMarkup'] != 'null' && row['ClientMarkup'] != '' && !row['ClientMarkup']) ? row['ClientMarkup'] + '%' : '$0.00 (USD)';
                }
                else {

                    if (colDetail['currencyCodeField']) {
                        retVal = this.currency.transform(cell, row[colDetail['currencyCodeField']], 'symbol-narrow', '1.2-2') +
                            " (" + row[colDetail['currencyCodeField']] + ")";
                    }
                }

            }
            else if (colDetail['dataFormat'] === 'percentToFixeddecimal') {
                const per=cell*100;
                retVal = Number(per).toFixed(2); 
            }
            else if (colDetail['dataFormat'] === 'htmDecode') {
                var div = document.createElement("div");
                div.innerHTML = cell;
                retVal = div.textContent || div.innerText;
            }
             else { // any new formatting needs to taken care.
                retVal = '' + cell;
            }
        } else {
            retVal = '' + cell;
        }

        if (retVal && retVal.search(/("|,|\n)/g) >= 0) {
            retVal = `"${retVal}"`;
        }
        return retVal;
    }
}